import { Metadata } from '../../../types/Metadata';
import AnchorAPIError from '../AnchorAPIError';

export async function fetchMyPodcastMetadata(): Promise<Metadata> {
  return new Promise((resolve, reject) => {
    fetch('/api/podcast/metadata', {
      credentials: 'same-origin',
    })
      .then(response => {
        if (response.status === 200) {
          response.json().then(responseJSON => {
            resolve(responseJSON);
          });
        } else if (response.status === 400) {
          reject(new AnchorAPIError(response, `Missing image`));
        } else {
          reject(
            new AnchorAPIError(
              response,
              `Non 200 response status: ${response.status}`
            )
          );
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}
